const changedPositionVersion = 'relevance country rank';

export const getPageComponentType = (isCancelledOrder) => (isCancelledOrder ? 'cancelled' : 'completed');

export const getPageElementVersion = (changedPosition) => (changedPosition ? changedPositionVersion : null);
